var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "c-order-details" },
    [
      _c("div", { staticClass: "c-order-details__row" }, [
        _c(
          "div",
          { staticClass: "c-order-details__column u-margin-bottom-small" },
          [
            _c("h2", { staticClass: "c-order-details__header t-heading-6" }, [
              _vm._v("\n        Shipping Address\n      ")
            ]),
            _vm._v(" "),
            _c("p", {
              staticClass: "c-order-details__indented",
              domProps: { innerHTML: _vm._s(_vm.order.shippingAddress) }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "c-order-details__column u-margin-bottom-small" },
          [
            _c("h2", { staticClass: "c-order-details__header t-heading-6" }, [
              _vm._v("\n        Billing Address\n      ")
            ]),
            _vm._v(" "),
            _c("p", {
              staticClass: "c-order-details__indented",
              domProps: { innerHTML: _vm._s(_vm.order.billingAddress) }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "c-order-details__row" }, [
        _c(
          "div",
          { staticClass: "c-order-details__column u-margin-bottom-small" },
          [
            _c("h2", { staticClass: "c-order-details__header t-heading-6" }, [
              _vm._v("\n        Shipping Method\n      ")
            ]),
            _vm._v(" "),
            _c(
              "p",
              { staticClass: "c-order-details__content" },
              [
                _vm.order.shippingMethods.length
                  ? _vm._l(_vm.order.shippingMethods, function(method, index) {
                      return _c("span", { key: index }, [
                        _vm._v("\n            " + _vm._s(method.title)),
                        _c("br")
                      ])
                    })
                  : _vm._e()
              ],
              2
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "c-order-details__column u-margin-bottom-small" },
          [
            _c("h2", { staticClass: "c-order-details__header t-heading-6" }, [
              _vm._v("\n        Payment Method\n      ")
            ]),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass:
                  "c-order-details__content c-order-details__indented"
              },
              [
                _vm.order.transactions.length
                  ? _vm._l(_vm.order.transactions, function(
                      transaction,
                      index
                    ) {
                      return _c(
                        "span",
                        { key: index },
                        [
                          transaction.payment_details.credit_card_company
                            ? [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      transaction.payment_details
                                        .credit_card_company
                                    ) +
                                    " ending in " +
                                    _vm._s(
                                      transaction.payment_details.credit_card_number.slice(
                                        -4
                                      )
                                    ) +
                                    "\n              "
                                ),
                                _c("br")
                              ]
                            : [
                                _vm._v(
                                  "\n              Other Payment Method (non-card)\n              "
                                ),
                                _c("br")
                              ]
                        ],
                        2
                      )
                    })
                  : [_vm._v("\n          No Transaction\n        ")]
              ],
              2
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "c-order-details__row" }, [
        _c(
          "div",
          { staticClass: "c-order-details__column u-margin-bottom-small" },
          [
            _c("h2", { staticClass: "c-order-details__header t-heading-6" }, [
              _vm._v("\n        Status\n      ")
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "c-order-details__indented" }, [
              _vm._v(
                "\n        Fulfillment Status: " +
                  _vm._s(_vm.order.labels.fulfillmentStatus)
              ),
              _c("br"),
              _vm._v(
                "\n        Financial Status: " +
                  _vm._s(
                    _vm.order.labels.financialStatus
                      ? _vm.order.labels.financialStatus
                      : "No Transaction"
                  ) +
                  "\n      "
              )
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _vm.order.trackingUrl
        ? _c(
            "a",
            { staticClass: "t-link", attrs: { href: _vm.order.trackingUrl } },
            [_vm._v("\n    Track Package\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("order-items", { attrs: { items: _vm.order.lineItems } }),
      _vm._v(" "),
      _c("order-totals", {
        attrs: {
          subtotal: _vm.order.subtotalPrice,
          tax: _vm.order.taxPrice,
          shipping: _vm.order.shippingPrice,
          discounts: _vm.order.discounts,
          price: _vm.order.totalPrice
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }